import { z } from 'zod';

export const oauthSchema = z.object({
  name: z.string(),
  uri: z.string(),
});
